import { ENV } from '../environment';
import axios from 'axios';
import { ContentBannerDetail } from '../model/content';

export const ContentService = () => {
  const getBanner = async (siteDomain: string, locale: string, targetIdentifier: string) =>
    await getData<ContentBannerDetail>(`${ENV.CONTENT_API_URL}/api/v1/middleBannerProvider`, {
      domain: siteDomain,
      locale,
      targetIdentifier,
    });

  const getData = async <T>(url: string, params: Record<string, string>) => {
    try {
      const data = await axios.request<T>({
        url: url,
        params,
        headers: { Accept: 'application/json', 'x-caller': 'loyalty-program' },
      });
      return data.data;
    } catch (error: any) {
      return undefined;
    }
  };

  return {
    getBanner,
  };
};
